/** @format */

import React, { memo } from 'react'
import { NavLink, useLocation } from 'react-router-dom'

import { getCurrentMenu } from 'utils'

import { Row } from './components'
import styles from './DevelopMenu.module.css'

export const DevelopMenu = memo(() => {
  const { pathname } = useLocation()

  const menu = getCurrentMenu(pathname)

  return (
    <menu className={styles.wrapper}>
      {menu.map(({ title, path, items }) => (
        <NavLink key={path} activeClassName={styles.isActiveItem} className={styles.item} to={path}>
          <p className={styles.item__text}>{title}</p>
          <div className={styles.items}>
            {items?.map((item) => (
              <Row key={item.path} {...item} />
            ))}
          </div>
        </NavLink>
      ))}
    </menu>
  )
})
